import React from 'react'
import { connect } from 'react-redux'
import { ThemeProvider, createTheme } from '@mui/material'
import {
  blue, blueGrey, brown, common, deepOrange, grey, indigo,
  lightBlue, lightGreen, lime, orange, red, yellow
} from '@mui/material/colors'

const palettes = {
  default: {
    mono: {
      main: grey[800],
      light: grey[700],
      dark: grey[900],
      contrastText: common.white
    },
    lightBack: {
      primary: grey[100],
      secondary: grey[300]
    },
    chat: {
      normal: grey[900],
      system: blue[700],
      userName: lightGreen[700]
    },
    chatSnack: {
      normal: grey[100],
      system: blue[300],
      userName: lightGreen[300],
      carret: grey[300]
    },
    action: {
      focus: lime[50],
      timerRunning: red[800],
      alert: red[100]
    },
    player: {
      elevation: 2,
      chatMark: blue[900],
      memo: grey[500],
      myTurn1: orange[100],
      myTurn2: deepOrange[200],
      pushed: deepOrange[100],
      order1: common.black,
      order2: grey[500],
      userDelay: red[300],
      additional: yellow[800]
    },
    score: {
      point: lightGreen[500],
      batsu: red[500],
      compPoint: indigo[500],
      win: lightBlue[200],
      lose: red[200],
      lock: grey[300],
      statusOpacity: 0.6,
      riichiWin: lightGreen[500],
      riichiLose: red[500]
    },
    board: {
      borderClosed: grey[300],
      borderOpened: grey[800],
      masterCorrect: red[100],
      masterWrong: blue[100],
      openText: common.white,
      openCorrect: red[800],
      openWrong: blue[800]
    },
    team: {
      border: blueGrey[200]
    },
    toObserver: {
      icon: grey[500],
      hover: red[100]
    }
  },
  dark: {
    mode: 'dark',
    mono: {
      main: grey[200],
      light: grey[100],
      dark: grey[300],
      contrastText: common.black
    },
    lightBack: {
      primary: grey[800],
      secondary: grey[600]
    },
    chat: {
      normal: grey[100],
      system: blue[300],
      userName: lightGreen[300]
    },
    chatSnack: {
      normal: grey[900],
      system: blue[700],
      userName: lightGreen[700],
      carret: grey[300]
    },
    action: {
      focus: blueGrey[900],
      timerRunning: red[200],
      alert: red[900]
    },
    player: {
      elevation: 4,
      chatMark: blue[100],
      memo: grey[500],
      myTurn1: brown[800],
      myTurn2: deepOrange[800],
      pushed: deepOrange[900],
      order1: common.white,
      order2: grey[400],
      userDelay: red[700],
      additional: yellow[800]
    },
    score: {
      point: lightGreen[500],
      batsu: red[500],
      compPoint: indigo[300],
      win: lightBlue[800],
      lose: red[800],
      lock: grey[700],
      statusOpacity: 0.7,
      riichiWin: lightGreen[500],
      riichiLose: red[500]
    },
    board: {
      borderClosed: grey[700],
      borderOpened: grey[200],
      masterCorrect: red[900],
      masterWrong: blue[900],
      openText: common.black,
      openCorrect: red[200],
      openWrong: blue[200]
    },
    team: {
      border: blueGrey[800]
    },
    toObserver: {
      icon: grey[500],
      hover: red[900]
    }
  }
}

const Theme = ({ children, setting: { personal } }) => {
  const theme = createTheme({
    palette: palettes[personal.display.theme],
    components: {
      MuiFormLabel: {
        styleOverrides: {
          root: {
            lineHeight: '1.2em'
          }
        }
      },
      MuiDialogContent: {
        styleOverrides: {
          root: {
            paddingBottom: '8px'
          }
        }
      }
    }
  })

  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  )
}

export default connect(
  state => ({
    setting: state.setting
  })
)(Theme)
